import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getAllRoutes } from './Login/login.async'
import * as CryptoJS from 'crypto-js'

// Define your encryption key
let ENCRYPTION_KEY = process.env.ENCRYPTION_KEY || 'ad00f82eed9f2e01e7a1e4e44ab71579'

// Function to encrypt data
const encryptData = (data) => {
  const dataToEncrypt = typeof data === 'string' ? data : JSON.stringify(data)

  try {
    const encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, ENCRYPTION_KEY).toString()
    // console.log('Encrypted Data:', encryptedData);  // Log the encrypted data
    return encryptedData
  } catch (err) {
    console.error('Error during encryption:', err)
    return '' // Return empty string on error
  }
}

// Function to decrypt data
const decryptData = (encryptedData) => {
  if (!encryptedData) {
    console.error('No encrypted data provided for decryption')
    return []
  }

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)

    if (!decrypted) {
      console.error('Decryption failed, no valid output')
      return [] // Return empty array if decryption fails
    }

    try {
      const parsedData = JSON.parse(decrypted)
      // console.log('Decrypted Data:', parsedData); // Log the decrypted data
      return parsedData
    } catch (err) {
      console.error('Failed to parse decrypted data:', err)
      return [] // Return empty array if parsing fails
    }
  } catch (err) {
    console.error('Error during decryption:', err)
    return [] // Return empty array if decryption fails
  }
}

// Helper function to get stored config IDs from localStorage
const getStoredConfigID = () => {
  const storedToken = localStorage.getItem('configIDs')
  if (storedToken) {
    // console.log('Stored configIDs:', storedToken) // Log for debugging
  } else {
    // console.log('No configIDs in localStorage')
  }
  return storedToken ? decryptData(storedToken) : []
}

const initialState = {
  allRouteList: [],
  isAccessDenied: false,
  allRouteListLoader: false,
  configID: getStoredConfigID(), // Storing decrypted config IDs
}

export const routeSlice = createSlice({
  name: 'reduxSlice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getAllRoutes.pending), (state) => {
      state.allRouteListLoader = true
    })
    builder.addMatcher(isAnyOf(getAllRoutes.fulfilled), (state, action) => {
      state.allRouteList = action.payload

      // Extracting all id values from the response
      const configIDs = action.payload.map((route) => ({
        route: route.id,
        access_level: route?.access_level,
      }))

      // Updating the state with the config IDs
      state.configID = configIDs

      // Encrypting and storing the config IDs in localStorage
      const encryptedConfigIDs = encryptData(configIDs)

      if (encryptedConfigIDs) {
        localStorage.setItem('configIDs', encryptedConfigIDs) // Store encrypted data
        // console.log('Encrypted Config IDs stored in localStorage:', encryptedConfigIDs);
      } else {
        console.error('Failed to encrypt configIDs')
      }
      state.allRouteListLoader = false
    })

    builder.addMatcher(isAnyOf(getAllRoutes.rejected), (state) => {
      state.allRouteList = []
      state.configID = []
      state.allRouteListLoader = false
    })
  },

  reducers: {
    setAccessDenied: (state, action) => {
      state.isAccessDenied = action.payload
    },
  },
})

export const { setAccessDenied } = routeSlice.actions

export default routeSlice.reducer
